import React from 'react'
import Select from 'react-select'
import LeaderboardTable from './LeaderboardTable'
import ChampCard from './ChampCard'
import { FaAngleLeft } from "react-icons/fa6";
import { FaAngleRight } from "react-icons/fa6";
import { AngleLeftIcon, AngleRightIcon } from '../../../SvgIconsData';


const Leaderboard = () => {
    const options = [
        { value: 'memory', label: 'Memory' },
        { value: 'nr', label: 'Numerical Reasoning' },
        { value: 'sa', label: 'Spatial Ability' },
        { value: 'ip', label: 'Information Processing' },
        { value: 'ad', label: 'Attention to Detail' }
    ]
    return (
        <>
            <div className="container-fluid p-4 leaderboard">
                <div className="row justify-content-end">
                    <div className="col-md-3 position-relative z-3">
                        <Select options={options} />
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-md-8 position-relative">
                        <span className='angleright'> <AngleLeftIcon /></span>
                        <ChampCard />
                        <span className='angleleft'><AngleRightIcon /> </span>
                    </div>
                </div>
                <div className="row pt-4 justify-content-center">
                    <div className="col-md-10">
                        <div className="row mb-2">
                            <div className="col-7">
                                <h6 style={{ paddingLeft: '55px' }}>Name </h6>
                            </div>
                            <div className="col-3">
                                <h6><strong>Score</strong></h6>
                            </div>
                            <div className="col-2">
                                <h6><strong>Time</strong></h6>
                            </div>
                        </div>
                        <LeaderboardTable />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Leaderboard
